import BusinessCardLayout from "@/layouts/BusinessCardLayout";

export default function HomePage() {
  return null;
}

HomePage.Layout = BusinessCardLayout;
